<!--
    file type .....: HTML file: pastassistance.component.html
    Created By ....: ianday
    Date ..........: 11/29/23 
-->
<div class="pastassistance-container" *ngIf="showPastAssistance">
    <div class="userhelp-div-style">
        Click on a row to see the detail
    </div>
    <div class="checkbox-div-style" *ngIf="showDenialRequests">
        <mat-checkbox [(ngModel)]="showDeniedServices"
                      (change)="doDeniedFlagChange()"
                      labelPosition="before">Show Denied Services</mat-checkbox>
    </div>

    <div #tb1 class="table-container mat-elevation-z1"
         (keydown)="tableKeyDown($event)" tabindex="-1">
        <table mat-table [dataSource]="dataSource" matSort style="width:100%"
               (matSortChange)="onSortChange($event)">

            <!--Date Completed -->
            <ng-container matColumnDef="dateCompleted">
                <th mat-header-cell *matHeaderCellDef
                    style="width: 120px"
                    class="mat-table-header-style-dark table-header-class"> Completed
                </th>
                <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.dateCompleted | date:'mediumDate':'EST'}} </td>
            </ng-container>

            <!--Request Type -->
            <ng-container matColumnDef="requestType">
                <th mat-header-cell *matHeaderCellDef class="mat-table-header-style-dark table-header-class"
                    style="width: 120px"> Request Type
                </th>
                <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.requestType}} </td>
            </ng-container>

            <!--Request Type -->
            <ng-container matColumnDef="totalAmountProvided">
                <th mat-header-cell *matHeaderCellDef class="mat-table-header-style-dark table-header-class">
                    Provided Amount
                </th>
                <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.totalAmountProvided}} </td>
            </ng-container>
            <!--Agency -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)">
            </tr>
        </table>
        <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
    </div>
    <!--- DETAIL SECTION --->
    <div class="detail-section">
        <div class="dwform dwform-cell-nopadding"
             style="min-width: 300px;padding-left: 0px;">  <!--RHS Fields -->

            <div class="dwform-row-gap"></div>
              <div class="dwform-row">
                  <label class="label-field label-field-override">Request Date:</label>
                  <span class="form-required"> </span>
                  <label class="label-field-data label-field-override">{{selectedRecord?.dateCreated | date:'mediumDate':'EST'}}</label>
            </div>
            <div class="dwform-row-gap"></div>

            <div class="dwform-row">
                <label class="label-field label-field-override">Completed Date:</label>
                <span class="form-required"> </span>
                <label class="label-field-data label-field-override" >{{selectedRecord?.dateCompleted | date:'mediumDate':'EST'}}</label>
            </div>

            <div class="dwform-row-gap"></div>
            <div class="dwform-row">
                <label class="label-field label-field-override">Request Type:</label>
                <span class="form-required"> </span>
                <label class="label-field-data label-field-override">{{selectedRecord?.requestType}}</label>
            </div>

            <div class="dwform-row-gap"></div>
            <div class="dwform-row">
                <label class="label-field label-field-override">Amount Requested:</label>
                <span class="form-required"> </span>
                <label class="label-field-data label-field-override">{{selectedRecord?.amountRequested}}</label>
            </div>
            <div class="dwform-row-gap"></div>

            <div class="dwform-row">
                 <label class="label-field label-field-override">Agency:</label>
                <span class="form-required"> </span>
                <label class="label-field-data label-field-override">{{selectedRecord?.agencyName}}</label>
            </div>

            <div class="dwform-row-gap"></div>
            <div class="dwform-row">
                <label class="label-field label-field-override">Status:</label>
                <span class="form-required"> </span>
                <label class="label-field-data label-field-override"
                       [ngStyle]="{ 'color': returnStatusColor(selectedRecord?.statusId)}">{{selectedRecord?.statusDescription}}</label>
            </div>
            <div class="dwform-row-gap"></div>
            <div class="dwform-row" *ngIf="showPreviousNeed">
                <label class="label-field label-field-override" style="padding-bottom:3px;">Previous Need:</label>
                <span class="form-required"> </span>
                <textarea class="ta-need-area label-field-override"
                          readonly="true">{{selectedRecord?.currentNeed}}</textarea>

            </div>
        </div>
    </div>
</div>
